import { useState } from 'react'

import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
} from 'app/common/ui-next/plain-modal'

import { useWarehouseStockItem } from 'app/dataProviders/warehouse/stock/hooks'
import { WarehouseStockItemId } from 'app/common/types/id'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'
import { PlainInputNumber } from 'app/common/ui-next/plain-input'
import PlainLabel from 'app/common/ui-next/plain-label'
import { toFixedValueInt } from 'app/common/lib/toFixedValue'

import styles from './StockEditModal.module.scss'

export const StockEditModal = ({
  id,
  title,
  stockQuantity: initialStockQuantity = 0,
  onClose,
  onSuccess,
}: {
  id: WarehouseStockItemId
  title?: string
  stockQuantity: number
  onClose: () => void
  onSuccess?: () => void
}) => {
  const { data, adjustQuantity } = useWarehouseStockItem({ params: { id } })
  const stockQuantity = data?.quantity ?? initialStockQuantity

  const [newStockQuantity, setNewStockQuantity] = useState('')

  const handleStockQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setNewStockQuantity(value.replace(/[^0-9]/g, ''))
  }

  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (form: HTMLFormElement) => {
    setSubmitting(true)
    const res = await adjustQuantity({ id, newQuantity: parseInt(newStockQuantity) })
    setSubmitting(false)
    if (res) onSuccess?.()
    onClose()
  }

  return (
    <PlainModal show formId="stock-editing" onSubmit={handleSubmit} className={styles.root}>
      <PlainModalHeader onCrossClick={onClose}>
        {title ? `Изменение остатков «${title}»` : 'Изменение остатков'}
      </PlainModalHeader>

      <PlainModalContent>
        <div className={styles.mainLayout}>
          <div>
            {'Остаток по продукции будет изменен'}
            <br />
            {'и создана операция инвентаризации.'}
          </div>

          <div className={styles.inputs}>
            <PlainLabel id="from" skipBottomSpace skipUpperSpace>
              {'С:'}
            </PlainLabel>
            <div aria-labelledby="from" className={styles.from}>
              {toFixedValueInt(stockQuantity)}
            </div>
            <PlainLabel htmlFor="input" skipBottomSpace skipUpperSpace>
              {'на:'}
            </PlainLabel>
            <PlainInputNumber
              name="input"
              hideArrows
              value={newStockQuantity}
              onChange={handleStockQuantityChange}
            />
          </div>
        </div>
      </PlainModalContent>

      <PlainModalFooter>
        <ControlsBar right>
          <PlainButton onClick={onClose} outline>
            {'Отмена'}
          </PlainButton>
          <PlainButton type="submit" disabled={!newStockQuantity || submitting}>
            {submitting ? 'Сохранение...' : 'Сохранить'}
          </PlainButton>
        </ControlsBar>
      </PlainModalFooter>
    </PlainModal>
  )
}
